/**
 * Transforme une ligne DB reçue par REST/WS
 * en un objet patient au format front.
 */
export function mapDbPatient(row) {
  if (!row) return null;
  let actesVA = row.actes_valeur_ajoutee ?? row.actesValeurAjoutee ?? {};
  if (typeof actesVA === 'string') {
    try {
      actesVA = JSON.parse(actesVA);
    } catch {
      actesVA = {};
    }
  }
  // Normalise snake_case & camelCase
  const dateNaissance = row.date_naissance ?? row.dateNaissance;
  const doctolibId = row.doctolib_id ?? row.doctolibId;
  const currentStep = Number(row.currentstep ?? row.currentStep ?? row.step ?? 0);
  // Normalisation heure d’entrée (préférer la colonne dédiée si fournie par l’API)
  const heureEntree =
    row.heure_entree ??
    row.heureEntree ??
    row.created_at ?? // fallback si vieux patients
    row.createdAt ??
    null;
  const cotationStatus = row.cotation_status ?? row.cotationStatus;
  const createdAt = row.created_at ?? row.createdAt;
  const tpFlag = row.tp_flag ?? row.tpFlag ?? null;
  const is_demo = Boolean(row.is_demo ?? row.isDemo ?? false);

  return {
    id: row.id,
    musiqId: row.musiqId ?? row.identifiant ?? null,
    nom: row.nom,
    prenom: row.prenom,
    civilite: row.civilite ? row.civilite : '',
    tp_flag: tpFlag,
    tpFlag,
    is_demo,
    dateNaissance,
    ddnFormatted: dateNaissance
      ? new Date(dateNaissance).toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      : null,
    doctolibId,
    identifiant: doctolibId,
    salle_id: row.salle_id,
    statut: row.statut,
    urgence: Boolean(row.urgence),
    cotationStatus,
    currentStep,
    isFinalized: currentStep === 999,
    createdAt,
    heureEntree,
    h_etape_4: row.h_etape_4 ?? row.hEtape4 ?? null,
    biologie: row.biologie,
    codes: row.codes ?? row.cotationCodes ?? row.cotation_codes ?? null,
    cotationLibre: row.cotation_libre ?? row.cotationLibre ?? null,
    // Cotation libre (champ texte saisi côté FichePatient)
    cotation_libre: row.cotation_libre ?? row.cotationLibre ?? null,
    cotation_json: row.cotation_json ?? null,
    isSheetsCalculating: row.isSheetsCalculating,
    date_rdv: row.date_rdv,
    type_salle: row.type_salle,
    etablissement_id: row.etablissement_id,
    actes_valeur_ajoutee: actesVA,
    actesValeurAjoutee: actesVA,
  };
}
/**
 * Transforme le payload provenant du PDF
 * en objet “incoming” pour POST /patients.
 */
export function mapIncomingPatient(rawPdf) {
  return {
    nom: rawPdf.nom,
    prenom: rawPdf.prenom,
    dateNaissance: rawPdf.date_naissance ?? rawPdf.dateNaissance ?? null,
    doctolibId: rawPdf.doctolib_id ?? rawPdf.doctolibId ?? rawPdf.identifiant ?? null,
    currentStep: 1,
    urgence: false,
    cotationStatus: 'non_commencée',
    salle: null,
  };
}
/**
 * Alias que vos pages importaient déjà
 */
export const mapImportedToPatient = mapIncomingPatient;

/**
 * Utility pour merger deux passages si nécessaire
 */
export function mergePatient(oldP, newP) {
  return { ...oldP, ...newP };
}
